import type { Domain } from "@/lib/api";
import type { CalendarItem } from "@/lib/overview";
import { css, cx } from "@styled-system/css";
import { HoverCard } from "./hover-card";

const base = css({
  display: "flex",
  gap: "6",
  alignItems: "baseline",
  px: "6",
  py: "3",
  borderRadius: "4",
  minW: "0",
  textDecoration: "none",
});

const FILL: Record<Domain, string> = {
  cetec: css({ bg: "domain.cetec.fill" }),
  mkbd: css({ bg: "domain.mkbd.fill" }),
  personal: css({ bg: "domain.personal.fill" }),
};
const INK: Record<Domain, string> = {
  cetec: css({ color: "domain.cetec" }),
  mkbd: css({ color: "domain.mkbd" }),
  personal: css({ color: "domain.personal" }),
};

const vault = css({ border: "[1px dashed]", borderColor: "border.bold" });
const label = css({ fontFamily: "mono", fontSize: "12", lineHeight: "tight", flexShrink: "0" });
const title = css({
  fontSize: "12",
  lineHeight: "tight",
  color: "text.bold",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
});

export function CalendarChip({ item }: { item: CalendarItem }) {
  const isVault = item.kind === "vault";
  const className = cx(base, isVault ? vault : FILL[item.domain]);
  const body = (
    <>
      <span className={cx(label, isVault ? css({ color: "text.warning" }) : INK[item.domain])}>
        {item.label}
      </span>
      <span className={title}>{item.title}</span>
    </>
  );
  const chip = item.url ? (
    <a href={item.url} target="_blank" rel="noreferrer" className={className}>
      {body}
    </a>
  ) : (
    <div className={className}>{body}</div>
  );
  return (
    <HoverCard title={item.title} lines={item.detail}>
      {chip}
    </HoverCard>
  );
}
